import {HTMLAttributes, useEffect, useRef} from 'react';
import {twMerge} from '../../../common/twMerge';
import {RadioV2} from '../../molecules/RadioV2/RadioV2';

interface DialogRadioProps extends HTMLAttributes<HTMLDivElement> {
  isChecked?: boolean;
}

export function DialogRadio({
  children,
  isChecked = false,
  className,
  ...props
}: DialogRadioProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && isChecked) {
      ref.current.focus();
    }
  }, [isChecked]);

  return (
    <div
      ref={ref}
      className={twMerge(
        'flex cursor-pointer items-center justify-start px-18pxr focus:outline-hidden h-56pxr rounded-12pxr',
        isChecked && 'bg-theme-etc-button-secondary',
        className
      )}
      tabIndex={0}
      {...props}
    >
      <RadioV2 checked={isChecked} />
      <div
        className={twMerge(
          'font-medium2 relative break-all text-center text-theme-solid-60 ml-8pxr',
          isChecked && 'text-theme-solid-100'
        )}
      >
        {children}
      </div>
    </div>
  );
}

export const DialogRadioType = (<DialogRadio />).type;
